<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="1200px"
  minHeight="90vh"
  (onClose)="cancel()"
>
  <div slot="children">
    <div
      *transloco="let t; read: 'widgets.widget-filter'"
      class="xi-modal__container widget-filter__container"
    >
      <div class="widget-filter__header-container xi-modal__title">
        <h2 class="widget-filter__title">{{ t('document-filters') }}</h2>
        <div>
          <input
            class="header-dataSource"
            [value]="
              t('datasource-numberof-docs', {
                dataSource: (widgetDataSource.displayName | truncate: 24),
                count: widgetDataSource.documentCount || 0 | humanizeInt,
              })
            "
            [disabled]="true"
            textSize="small"
          />
        </div>
      </div>

      <div class="xi-modal__content widget-filter__content">
        <div class="filter-header">
          {{ headerText }}
        </div>

        <div class="columns">
          <div class="widget-filter__available">
            <div class="widget-filter__available-top-section">
              <h2>{{ t('available') }}</h2>
              <div>
                <div class="widget-filter__available-refresh-pill">
                  <xi-icon-button
                    icon="refresh"
                    color="CX"
                    fill="no-fill"
                    buttonSize="large"
                    [disabled]="isLoading.filters"
                    (onClick)="refresh()"
                  ></xi-icon-button>

                  @if (hasChanges) {
                    <div>
                      <xi-custom-pill color="CX" [text]="filterChangeCount"></xi-custom-pill>
                    </div>
                  }
                </div>
              </div>
            </div>

            <xi-horizontal-tab-bar
              [data]="widgetFilterTabs"
              [(activeTabId)]="activeTab"
              [tabSpacing]="25"
              color="CX"
              [hasTransparentBackground]="true"
              (onTabChange)="onTabChange()"
            >
            </xi-horizontal-tab-bar>

            @if (activeTab === 'analytics') {
              <div class="widget-filter__tab-content">
                <ng-container
                  *ngTemplateOutlet="
                    analyticItemFilterTemplate;
                    context: {
                      items: analyticItems,
                      keys: analyticItemKeys,
                      noMatch: noAnalyticMatch,
                      noMatchText: t('no-documents-match-filters'),
                      activeTab: activeTab,
                    }
                  "
                ></ng-container>
              </div>
            }
            @if (activeTab === 'metadata') {
              <div class="widget-filter__tab-content">
                <ng-container
                  *ngTemplateOutlet="
                    analyticItemFilterTemplate;
                    context: {
                      items: metadataItems,
                      keys: metadataItemKeys,
                      noMatch: noMetadataMatch,
                      noMatchText: noMetadataText,
                      activeTab: activeTab,
                    }
                  "
                ></ng-container>
              </div>
            }
            @if (activeTab === 'taxonomy') {
              <div class="widget-filter__tab-content">
                <ng-container *ngTemplateOutlet="tTaxonomyPicker"></ng-container>
              </div>
            }
            @if (activeTab === 'text') {
              <div class="widget-filter__tab-content">
                <ng-container *ngTemplateOutlet="tSearchFilter"></ng-container>
              </div>
            }

            <ng-template #tTaxonomyPicker>
              <app-taxonomy-picker
                [selectMultiple]="true"
                [showUncategorized]="true"
                [showRevert]="false"
                [showDocumentCount]="true"
                [query]="query"
                [selectedNodeIds]="originalTaxonomySelectedItems"
                [disabledNodeIds]="originalTaxonomySelectedItems"
                [projectId]="widget.payload.projectId"
                [widgetDataSource]="widgetDataSource"
                (selectionChange)="onTaxonomySelectionChanged($event)"
              ></app-taxonomy-picker
            ></ng-template>

            <ng-template #fiterMetadataFieldsTemplate let-popover>
              <div class="filter-metadata-popover">
                <div class="filter-metadata-popover-header">
                  <h3 class="kxi-text-600 kxi-text-normal">
                    {{ addfieldPopoverMode ? t('add-fields-header') : t('remove-fields-header') }}
                  </h3>
                </div>
                <div class="filter-meta-popover-list">
                  <xi-list
                    #popoverList
                    [hasSearch]="true"
                    size="normal"
                    select="multi"
                    [internalProps]="addfieldPopoverMode ? internalPropsAdd : internalPropsRemove"
                  >
                    <div slot="children">
                      @for (
                        f of addfieldPopoverMode
                          ? filteredUnfilterableCustomFields
                          : filteredFilterableCustomFields;
                        track f
                      ) {
                        <xi-list-item
                          [attr.id]="f.id"
                          [value]="f.id"
                          select="multi"
                          (onItemClick)="onPopoverFieldSelected(f)"
                        >
                          <div slot="children">{{ f.description }}</div>
                        </xi-list-item>
                      }
                    </div>
                  </xi-list>
                </div>
                @if (addfieldPopoverMode) {
                  <div class="filter-meta-popover-temp">
                    <xi-checkbox
                      [(ngModel)]="metaTemporaryChecked"
                      color="CX"
                      [label]="t('temporary')"
                    ></xi-checkbox>
                    <xi-tool-tip-content
                      class="temp-tooltip"
                      [tooltip]="{ text: t('temporary-tooltip') }"
                    ></xi-tool-tip-content>
                  </div>
                }
                <div class="filter-meta-popover-actions">
                  <xi-default-button
                    class="cancel-popover"
                    [text]="t('cancel')"
                    (onClick)="closePopover(true)"
                  ></xi-default-button>
                  @if (addfieldPopoverMode) {
                    <xi-default-button
                      class="confirm-popover"
                      [text]="t('add')"
                      (onClick)="addFilterMetadata()"
                    ></xi-default-button>
                  }
                  @if (!addfieldPopoverMode) {
                    <xi-default-button
                      class="confirm-popover"
                      [text]="t('remove')"
                      (onClick)="removeFilterMetadata()"
                    ></xi-default-button>
                  }
                </div>
              </div>
            </ng-template>

            <ng-template
              #analyticItemFilterTemplate
              let-items="items"
              let-keys="keys"
              let-noMatch="noMatch"
              let-noMatchText="noMatchText"
              let-activeTab="activeTab"
            >
              <div class="widget-filter__analytics-search">
                <xi-search-box
                  [placeholder]="t('search-for-filters')"
                  name="modelSearch"
                  [(ngModel)]="modelSearch"
                  [isFiredOnEnter]="true"
                  (onChangeOverride)="onSearchChange()"
                  (onCancelClick)="onSearchChange(true)"
                  [disabled]="isLoading.filters"
                ></xi-search-box>
                <xi-default-button
                  [text]="t('search')"
                  [disabled]="modelSearch.length < 3"
                  [tooltipDisplayOnDisabled]="true"
                  [tooltip]="
                    modelSearch.length < 3 ? { text: t('search-minimum-characters') } : null
                  "
                  color="CX"
                  (onClick)="refresh()"
                ></xi-default-button>
                @if (activeTab === 'metadata') {
                  <div
                    #fiterMetadataRemovePopover="ngbPopover"
                    [ngbPopover]="fiterMetadataFieldsTemplate"
                    (click)="openFilterMetadataRemovePopover(fiterMetadataRemovePopover, $event)"
                    popoverClass="filter-metadata-popover"
                    placement="bottom"
                    triggers="manual"
                    [autoClose]="false"
                    [container]="'body'"
                    [matTooltip]="
                      filteredFilterableCustomFields.length > 0
                        ? t('remove-fields-tooltip')
                        : t('remove-fields-tooltip-disabled')
                    "
                    [matTooltipPosition]="'above'"
                  >
                    <xi-icon-button
                      [disabled]="filteredFilterableCustomFields.length < 1"
                      icon="indeterminate"
                      color="CX"
                      fill="fill"
                      buttonSize="medium"
                    ></xi-icon-button>
                  </div>
                }
                @if (activeTab === 'metadata') {
                  <div
                    #fiterMetadataAddPopover="ngbPopover"
                    [ngbPopover]="fiterMetadataFieldsTemplate"
                    (click)="openFilterMetadataAddPopover(fiterMetadataAddPopover, $event)"
                    popoverClass="filter-metadata-popover"
                    placement="bottom"
                    triggers="manual"
                    [autoClose]="false"
                    [container]="'body'"
                    [matTooltip]="
                      filteredUnfilterableCustomFields.length > 0
                        ? t('add-fields-tooltip')
                        : t('add-fields-tooltip-disabled')
                    "
                    [matTooltipPosition]="'above'"
                  >
                    <xi-icon-button
                      [disabled]="filteredUnfilterableCustomFields.length < 1"
                      icon="fab_plus"
                      color="CX"
                      fill="fill"
                      buttonSize="medium"
                    ></xi-icon-button>
                  </div>
                }
              </div>

              @if (isLoading.filters) {
                <div class="filter-loading">
                  <xi-animation
                    [width]="200"
                    [height]="200"
                    [loop]="true"
                    animation="cx_loader"
                  ></xi-animation>
                </div>
              }
              @if (!isLoading.filters) {
                @if (noMatch) {
                  <div class="no-documents">
                    {{ noMatchText }}
                  </div>
                }
                @if (items.length > 0) {
                  <mat-accordion #accordion>
                    @for (analyticItem of items; track analyticItem) {
                      <mat-expansion-panel
                        [attr.data-category]="analyticItem"
                        [expanded]="currentAccordionItem.item === analyticItem"
                        (opened)="setExpandedState(true, analyticItem)"
                        (closed)="setExpandedState(false, analyticItem)"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-title>{{
                            analyticItemDisplayMap[analyticItem] || analyticItem
                          }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (!keys[analyticItem].initialized) {
                          <div class="xi-loader-container__center">
                            <xi-animation
                              [width]="200"
                              [height]="200"
                              [loop]="true"
                              animation="cx_loader"
                            ></xi-animation>
                          </div>
                        }
                        @if (keys[analyticItem].initialized) {
                          @if (keys[analyticItem].hasResults) {
                            @if (!keys[analyticItem].hasChoicesFor) {
                              <div>
                                @if (keys[analyticItem].isMultiLevel) {
                                  <mat-accordion>
                                    @for (
                                      rollupLabel of keys[analyticItem].subLabels.labels;
                                      track rollupLabel
                                    ) {
                                      @if (
                                        keys[analyticItem].subLabels.keys[rollupLabel].length > 0
                                      ) {
                                        <mat-expansion-panel
                                          [attr.data-category]="analyticItem + ':' + rollupLabel"
                                          [expanded]="
                                            currentAccordionItem.item === analyticItem &&
                                            currentAccordionItem.rollupLabel === rollupLabel
                                          "
                                          (opened)="
                                            setExpandedState(true, analyticItem, rollupLabel)
                                          "
                                          (closed)="
                                            setExpandedState(false, analyticItem, rollupLabel)
                                          "
                                        >
                                          <mat-expansion-panel-header>
                                            <mat-panel-title>{{
                                              rollupLabel | titlecase
                                            }}</mat-panel-title>
                                          </mat-expansion-panel-header>
                                          <mat-list class="ellipsis">
                                            @for (
                                              key of keys[analyticItem].subLabels.keys[rollupLabel];
                                              track key
                                            ) {
                                              <mat-list-item>
                                                <div
                                                  class="widget-filter__checkbox-wrapper"
                                                  [matTooltip]="
                                                    analyticItemKeyDisplayMap[analyticItem + key]
                                                      .length > 29
                                                      ? analyticItemKeyDisplayMap[
                                                          analyticItem + key
                                                        ]
                                                      : ''
                                                  "
                                                >
                                                  <xi-checkbox
                                                    color="CX"
                                                    [label]="
                                                      analyticItemKeyDisplayMap[analyticItem + key]
                                                        | truncate: 29
                                                    "
                                                    [checked]="
                                                      selectedMap[analyticItem + key + rollupLabel]
                                                    "
                                                    (onChange)="
                                                      toggleSelected(analyticItem, key, rollupLabel)
                                                    "
                                                  ></xi-checkbox>
                                                </div>
                                                <span class="document-count" matSuffix>
                                                  {{
                                                    analyticItemKeyCountMap[
                                                      analyticItem + key + rollupLabel
                                                    ]
                                                  }}
                                                </span>
                                              </mat-list-item>
                                            }
                                            @if (hasMore(analyticItem, rollupLabel)) {
                                              <div class="show-more-link">
                                                <span
                                                  (click)="
                                                    showMore(keys, analyticItem, rollupLabel)
                                                  "
                                                >
                                                  {{ t('show-more') }}
                                                </span>
                                              </div>
                                            }
                                          </mat-list>
                                        </mat-expansion-panel>
                                      }
                                    }
                                  </mat-accordion>
                                }
                                @if (!keys[analyticItem].isMultiLevel) {
                                  <mat-list class="ellipsis">
                                    @if (showEqualsExistsRadios(analyticItem)) {
                                      <mat-list-item>
                                        <mat-radio-group
                                          class="equals-exists-radio__container"
                                          [(ngModel)]="modelEqualsExistsRadio"
                                          (change)="onEqualsExistsRadioChange(analyticItem)"
                                        >
                                          <mat-radio-button value="_equals_">{{
                                            t('equals')
                                          }}</mat-radio-button>
                                          <mat-radio-button value="_exists_">{{
                                            t('exists')
                                          }}</mat-radio-button>
                                          <mat-radio-button value="_notExists_">{{
                                            t('does-not-exist')
                                          }}</mat-radio-button>
                                        </mat-radio-group>
                                      </mat-list-item>
                                    }
                                    @for (
                                      key of keys[analyticItem].keys;
                                      track key;
                                      let i = $index
                                    ) {
                                      <mat-list-item>
                                        <div
                                          class="widget-filter__checkbox-wrapper"
                                          [matTooltip]="
                                            analyticItemKeyDisplayMap[analyticItem + key].length >
                                            29
                                              ? analyticItemKeyDisplayMap[analyticItem + key]
                                              : ''
                                          "
                                        >
                                          <xi-checkbox
                                            color="CX"
                                            [label]="
                                              analyticItemKeyDisplayMap[analyticItem + key]
                                                | truncate: 29
                                            "
                                            [checked]="selectedMap[analyticItem + key]"
                                            (onChange)="toggleSelected(analyticItem, key)"
                                            [disabled]="modelEqualsExistsRadio !== '_equals_'"
                                          >
                                          </xi-checkbox>
                                        </div>
                                        <span class="document-count" matSuffix>
                                          {{ analyticItemKeyCountMap[analyticItem + key] }}
                                        </span>
                                      </mat-list-item>
                                    }
                                    @if (hasMore(analyticItem)) {
                                      <div class="show-more-link">
                                        <span (click)="showMore(keys, analyticItem)">{{
                                          t('show-more')
                                        }}</span>
                                      </div>
                                    }
                                  </mat-list>
                                }
                              </div>
                            }
                            @if (keys[analyticItem].hasChoicesFor) {
                              <mat-list class="ellipsis">
                                @switch (configTypeMap[analyticItem]) {
                                  @case ('radio') {
                                    <mat-radio-group>
                                      @for (choice of keys[analyticItem].choicesFor; track choice) {
                                        <mat-list-item>
                                          <div class="widget-filter__date-range-radio-wrapper">
                                            <xi-radio
                                              [label]="choice.label"
                                              [checked]="
                                                selectedMap[
                                                  analyticItem + choice.key
                                                    ? choice.key
                                                    : choice.value.toString()
                                                ]
                                              "
                                              [value]="choice"
                                              (onChange)="
                                                toggleSelectedChoice(analyticItem, choice)
                                              "
                                            >
                                            </xi-radio>
                                          </div>
                                        </mat-list-item>
                                      }
                                    </mat-radio-group>
                                  }
                                  @case ('date') {
                                    <mat-list-item class="daterange-list-item">
                                      <div class="daterange-selector-wrapper">
                                        <xi-radio
                                          value="relative"
                                          [label]="t('relative')"
                                          [(ngModel)]="dateResolution"
                                          (onChange)="toggleSelectedDateChoice(analyticItem)"
                                          name="dateRangeType"
                                        ></xi-radio>
                                        <xi-dropdown
                                          color="CX"
                                          [data]="keys[analyticItem].choicesFor"
                                          [value]="selectedDateChoice"
                                          (onValueChange)="
                                            toggleSelectedDateChoice(
                                              analyticItem,
                                              $event.detail.selected.id
                                            )
                                          "
                                        ></xi-dropdown>
                                        <xi-radio
                                          value="fixed"
                                          [label]="t('fixed')"
                                          [(ngModel)]="dateResolution"
                                          (onChange)="toggleSelectedDateChoice(analyticItem)"
                                          name="dateRangeType"
                                        ></xi-radio>
                                        <div class="choice daterange">
                                          <xi-date-picker
                                            [placeholder]="t('from')"
                                            [maxDate]="modelDaterangeTo"
                                            [dateValue]="modelDaterangeFrom"
                                            (onDateChange)="
                                              onDateChanged(
                                                analyticItem,
                                                'modelDaterangeFrom',
                                                $event.detail.date
                                              )
                                            "
                                          ></xi-date-picker>
                                          <span>to</span>
                                          <xi-date-picker
                                            [placeholder]="t('to')"
                                            [minDate]="modelDaterangeFrom"
                                            [dateValue]="modelDaterangeTo"
                                            (onDateChange)="
                                              onDateChanged(
                                                analyticItem,
                                                'modelDaterangeTo',
                                                $event.detail.date
                                              )
                                            "
                                          ></xi-date-picker>
                                        </div>
                                      </div>
                                    </mat-list-item>
                                  }
                                  @case ('checkbox') {
                                    @for (choice of keys[analyticItem].choicesFor; track choice) {
                                      <mat-list-item>
                                        <div
                                          class="widget-filter__checkbox-wrapper"
                                          [matTooltip]="
                                            choice.label.length > 29 ? choice.label : ''
                                          "
                                        >
                                          <xi-checkbox
                                            color="CX"
                                            [label]="choice.label | truncate: 29"
                                            [checked]="
                                              selectedMap[
                                                analyticItem + choice.key
                                                  ? choice.key
                                                  : choice.value.toString()
                                              ]
                                            "
                                            (onChange)="toggleSelectedChoice(analyticItem, choice)"
                                          ></xi-checkbox>
                                        </div>
                                      </mat-list-item>
                                    }
                                  }
                                  @case ('numeric') {
                                    <div class="numeric-wrapper">
                                      <select
                                        [(ngModel)]="modelNumericValue.leftOperand.operator"
                                        (change)="toggleSelectedNumeric(analyticItem)"
                                      >
                                        <option value="<=">≤</option>
                                        <option value="<"><</option>
                                        <option value="=">=</option>
                                        <option value=">">></option>
                                        <option value=">=">≥</option>
                                        @if (!isTextualSize(analyticItem)) {
                                          <option value="_exists_">{{ t('exists') }}</option>
                                          <option value="_notExists_">
                                            {{ t('does-not-exist') }}
                                          </option>
                                        }
                                      </select>

                                      <input
                                        appNumericInput
                                        [allowNegative]="true"
                                        [allowFractional]="isDoubleCustomField(analyticItem)"
                                        [(ngModel)]="modelNumericValue.leftOperand.value"
                                        (input)="toggleSelectedNumeric(analyticItem)"
                                        [disabled]="
                                          isExistsValue(modelNumericValue.leftOperand.operator)
                                        "
                                      />
                                      @if (modelNumericValue.booleanOperator !== 'OR') {
                                        <div
                                          [ngStyle]="{
                                            'grid-column': modelNumericValue.booleanOperator
                                              ? '1 / span 2'
                                              : '',
                                          }"
                                        >
                                          <xi-checkbox
                                            color="CX"
                                            [label]="t('AND')"
                                            [disabled]="!isModelNumericOperatorAllowed()"
                                            [checked]="modelNumericValue.booleanOperator === 'AND'"
                                            (onChange)="
                                              setNumericOperator(
                                                $event.detail.target,
                                                analyticItem,
                                                'AND'
                                              )
                                            "
                                          ></xi-checkbox>
                                        </div>
                                      }
                                      @if (modelNumericValue.booleanOperator !== 'AND') {
                                        <div
                                          [ngStyle]="{
                                            'grid-column': modelNumericValue.booleanOperator
                                              ? '1 / span 2'
                                              : '',
                                          }"
                                        >
                                          <xi-checkbox
                                            color="CX"
                                            [label]="t('OR')"
                                            [disabled]="!isModelNumericOperatorAllowed()"
                                            [checked]="modelNumericValue.booleanOperator === 'OR'"
                                            (onChange)="
                                              setNumericOperator(
                                                $event.detail.target,
                                                analyticItem,
                                                'OR'
                                              )
                                            "
                                          ></xi-checkbox>
                                        </div>
                                      }
                                      <select
                                        [(ngModel)]="modelNumericValue.rightOperand.operator"
                                        [disabled]="!modelNumericValue.booleanOperator"
                                        (change)="toggleSelectedNumeric(analyticItem)"
                                      >
                                        <option value="<=">≤</option>
                                        <option value="<"><</option>
                                        <option value="=">=</option>
                                        <option value=">">></option>
                                        <option value=">=">≥</option>
                                      </select>

                                      <input
                                        appNumericInput
                                        [allowNegative]="true"
                                        [allowFractional]="isDoubleCustomField(analyticItem)"
                                        [disabled]="!modelNumericValue.booleanOperator"
                                        [(ngModel)]="modelNumericValue.rightOperand.value"
                                        (input)="toggleSelectedNumeric(analyticItem)"
                                      />
                                    </div>
                                  }
                                }
                              </mat-list>
                            }
                          } @else {
                            <div class="no-documents">
                              {{ t('no-results-for-filters') }}
                              @if (userQueryInvalidText) {
                                <div>{{ userQueryInvalidText }}</div>
                              }
                            </div>
                          }
                        }
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                }
              }
            </ng-template>

            <ng-template #tSearchFilter>
              <app-document-list-saved-search
                [displayedSelectedFilters]="displayedSelectedFilters"
                [userSavedSearches]="userSavedSearches"
                [widget]="options.widget"
                [dashboard]="options.dashboard"
                (selectionChange)="onSearchSelectionChanged($event)"
                (itemRemoved)="onSearchTextItemRemoved($event)"
              ></app-document-list-saved-search>
            </ng-template>
          </div>

          <div class="selection">
            <h2>{{ t('selected') }}</h2>
            <xi-horizontal-tab-bar
              [data]="sectionFilterTabs"
              [(activeTabId)]="activeSectionTab"
              [tabSpacing]="25"
              color="CX"
              [hasTransparentBackground]="true"
              (onTabChange)="onSectionTabChange()"
            >
            </xi-horizontal-tab-bar>
            @if (activeSectionTab === 'documents') {
              <ng-container
                *ngTemplateOutlet="
                  filterTemplate;
                  context: { showSectionFilter: activeSectionTab === 'sections' }
                "
              ></ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  filterTemplate;
                  context: { showSectionFilter: activeSectionTab === 'sections' }
                "
              ></ng-container>
            }

            <ng-template #filterTemplate let-showSectionFilter="showSectionFilter">
              <div class="scroll-container">
                <ng-container
                  *ngTemplateOutlet="
                    filterSelection;
                    context: {
                      operator: 'and',
                      header: t('all-of-these'),
                      showSectionFilter: showSectionFilter,
                    }
                  "
                ></ng-container>

                @if (activeSectionTab === 'documents') {
                  <ng-container
                    *ngTemplateOutlet="
                      filterSelection;
                      context: {
                        operator: 'or',
                        header: t('any-of-these'),
                        showSectionFilter: showSectionFilter,
                      }
                    "
                  ></ng-container>

                  <ng-container
                    *ngTemplateOutlet="
                      filterSelection;
                      context: {
                        operator: 'not',
                        header: t('none-of-these'),
                        showSectionFilter: showSectionFilter,
                      }
                    "
                  ></ng-container>
                }

                <ng-template
                  #filterSelection
                  let-operator="operator"
                  let-header="header"
                  let-showSectionFilter="showSectionFilter"
                >
                  <div
                    class="container"
                    [ngClass]="{
                      'widget-filter__container-flex':
                        (operator === 'and' &&
                          showSectionFilter &&
                          isSectionFilteringInitialized &&
                          isSectionFilteringActive) ||
                        (showSectionFilter &&
                          isSectionFilteringInitialized &&
                          !isSectionFilteringActive) ||
                        !showSectionFilter,
                    }"
                  >
                    <div class="group-header">
                      <span>{{ header }}</span>

                      <div class="double-divider"></div>
                    </div>

                    <div class="widget-filter__filter-section-content">
                      @if (showSectionFilter) {
                        @if (isSectionFilteringInitialized && showSections && operator === 'and') {
                          <div class="widget-filter__filter-section-selector">
                            <app-section-selector
                              [sectionMetadata]="sectionMetadata"
                              [value]="selectedSections"
                              [forFilters]="true"
                              [isToggled]="isSectionFilteringActive"
                              [disabled]="
                                (!hasSections && !isSectionFilteringActive) ||
                                cantModifySectionFilterDueToWg
                              "
                              (sectionSelect)="onSectionSelected($event)"
                              (onToggle)="onToggleSectionFiltering($event)"
                            ></app-section-selector>
                          </div>
                        }
                      }
                      <mat-chip-listbox>
                        @for (
                          item of displayedSelectedFilters[operator]
                            | sectionFilter: showSectionFilter;
                          track item
                        ) {
                          <ng-container
                            *ngTemplateOutlet="filterPill; context: { item, operator }"
                          ></ng-container>
                        }
                      </mat-chip-listbox>
                      <xi-icon-button
                        icon="fab_plus"
                        buttonSize="large"
                        class="widget-filter__add-button-normal"
                        [ngClass]="{
                          invisible:
                            selected.length === 0 ||
                            !isOperatorAllowedMap[operator] ||
                            (showSectionFilter &&
                              isSectionFilteringInitialized &&
                              !isSectionFilteringActive),
                          'widget-filter__add-button-shrinked':
                            showSectionFilter &&
                            operator !== 'and' &&
                            isSectionFilteringInitialized &&
                            isSectionFilteringActive,
                        }"
                        (onClick)="add(operator, showSectionFilter)"
                      ></xi-icon-button>

                      <ng-template #filterPill let-item="item" let-operator="operator">
                        <app-lex-xi-filter-pill
                          [filter]="item"
                          [dataSource]="widgetDataSource.displayName"
                          [isParentFilter]="item['fromWidgetGroupParent']"
                          [isPillDisabled]="
                            !(!item['fromWidgetGroup'] && !item['fromWidgetGroupParent']) &&
                            !(forWidgetGroup() && !item['fromWidgetGroupParent'])
                          "
                          [filterOperator]="operator"
                          [selectedFilters]="displayedSelectedFilters"
                          [sectionFiltering]="isSectionFilteringActive"
                          [userSearch]="item.analyticItem === 'userSearch'"
                          (filterAction)="onFilterAction($event, operator, item)"
                        ></app-lex-xi-filter-pill>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="xi-modal__actions widget-filter__actions">
        <xi-default-button
          [text]="t('cancel')"
          fill="text"
          (onClick)="cancel()"
        ></xi-default-button>
        <div class="widget-filter__actions-right-side">
          @if (hasSelectedFilters) {
            <xi-default-button
              [text]="t('clear-all-filters')"
              fill="outline"
              (onClick)="clearAllFilters()"
            ></xi-default-button>
          }
          <!--If I just ngIf the button then it breaks the entire display.-->
          @if (!forWidgetGroup()) {
            <xi-default-button
              [text]="t('apply-plus-clone')"
              (onClick)="confirm(true)"
            ></xi-default-button>
            <xi-default-button [text]="t('apply')" (onClick)="confirm()"></xi-default-button>
          }
          @if (forWidgetGroup()) {
            <xi-default-button [text]="t('apply')" (onClick)="confirm()"></xi-default-button>
          }
        </div>
      </div>
    </div>
  </div>
</xi-generic-modal>
